import { render, staticRenderFns } from "./RegisterChild.vue?vue&type=template&id=6437158a&scoped=true&"
import script from "./RegisterChild.vue?vue&type=script&lang=js&"
export * from "./RegisterChild.vue?vue&type=script&lang=js&"
import style0 from "./RegisterChild.vue?vue&type=style&index=0&id=6437158a&scoped=true&lang=css&"
import style1 from "./RegisterChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437158a",
  null
  
)

export default component.exports